import IonIcon from '@reacticons/ionicons'
import { useRouter } from 'next/router'

interface Props {
  slug: string
  solutionType: string
}

export const EditListingButton: React.FC<Props> = ({ slug, solutionType }) => {
  const router = useRouter()

  return (
    <button
      onClick={() => router.push(`/edit-listing/${solutionType}/${slug}/`)}
      className="box-border h-[45px] w-[160px] border-solid border-[1px] border-mist rounded-full bg-navy text-white items-center justify-center font-semibold flex flex-row"
    >
      <IonIcon name="create-outline" className="text-[24px] mr-2 -mt-1" />
      Edit Listing
    </button>
  )
}
